/*
 *
 * File JS per la Homepage
 *
 */

//IMPORT SWIPER
//--------------------------------------------------------------------//

import Swiper , {Navigation , A11y} from "swiper";

//--------------------------------------------------------------------//

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import postModules from "components/post-modules/post-modules";
import cardNews from "../../components/cards/card-news";
import pagination from "../../components/pagination/pagination";
import blockNewsMedia from "../../components/block-news-media/block-news-media";
import banner from "../../components/banner/banner";
import bannerWide from "../../components/banner_wide/banner_wide";
import blockVideo from "../../components/block-video/block-video";
import gallery from "../../components/block-gallery/block-gallery";
import blockApp from "../../components/block-app/block-app";
import sliderHero from "../../components/home-slider/home-slider";
import download_cta from "../../components/block-download-cta/download_cta";
import blockPorducts from "../../components/block-products/block-products";

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./homepage.scss";

//--------------------------------------------------------------------//

//Function For HomePage
//--------------------------------------------------------------------//

const calendarioSwiper = () => {
  const calendarioPad = document.querySelector("#calendario_pad");
  const prevButton = document.querySelector("#calendario_pad .swiper-button-prev");
  const nextButton = document.querySelector("#calendario_pad .swiper-button-next");

  if (!calendarioPad | !prevButton | !nextButton) return;

  const calendarioSwiper = new Swiper("#calendario", {
    modules: [Navigation, A11y],
    // navigation: {
    //   nextEl: "#calendario_pad > .swiper-button-next",
    //   prevEl: "#calendario_pad > .swiper-button-prev",
    // },
    breakpoints: {
      768: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 4,
      },
      1025: {
        slidesPerView: 5,
      },
    },
    A11y: {
      enabled: true,
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      notificationClass: "swiper-notification",
    },
  });

  nextButton.addEventListener("click", () => {
    calendarioSwiper.slideNext(); 
  });

  prevButton.addEventListener("click", () => {
    calendarioSwiper.slidePrev(); 
  });

  const currentScudetto = document.querySelector(".scudetto.current");
  const swiperSlideParent = closestByClass(currentScudetto, "swiper-slide");
  const mio_current = Array.from(swiperSlideParent.parentNode.children).indexOf(swiperSlideParent);

  calendarioSwiper.slideTo(mio_current);

  // Funzione per trovare il genitore by class
  function closestByClass(element, className) {
    while (element) {
      if (element.classList.contains(className)) {
        return element;
      }
      element = element.parentNode;
    }
    return null;
  }
};

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//

calendarioSwiper();
blockPorducts();
postModules();
gallery();
// sliderAuthors();

//--------------------------------------------------------------------//
